module.exports = __webpack_public_path__ + "images/avatar-s-14.93df8c5c.jpg";